export const SET_SNACKBAR = 'SET_SNACKBAR';

export const ADD_TASK = 'ADD_TASK';
export const TOGGLE_TASK = 'TOGGLE_TASK';
export const CLEAR_COMPLETED_TASKS = 'CLEAR_COMPLETED_TASKS';

export const SET_USER = 'SET_USER';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const AUTHENTICATED = 'AUTHENTICATED';

export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const AUTH_ME_REQUEST = 'AUTH_ME_REQUEST';
export const AUTH_ME_SUCCESS = 'AUTH_ME_SUCCESS';
export const AUTH_ME_FAILED = 'AUTH_ME_FAILED';

export const SET_DASHBOARD_PRODUCTS = 'SET_DASHBOARD_PRODUCTS';
export const SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER';
export const SET_DASHBOARD_FILTER_ITEM = 'SET_DASHBOARD_FILTER_ITEM';
export const RESET_DASHBOARD_FILTER = 'RESET_DASHBOARD_FILTER';

export const SET_ORDER_TYPES = 'SET_ORDER_TYPES';
export const SET_ORDER_STATISTIC = 'SET_ORDER_STATISTIC';
export const SET_ORDER_WIDGET = 'SET_ORDER_WIDGET';

export const SET_ALERT_OPTIONS = 'SET_ALERT_OPTIONS';
export const AUTH_LOGIN_FAILED = 'AUTH_LOGIN_FAILED';
export const SET_ORDERS = 'SET_ORDERS';

export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL';
export const SET_GIMMICK_POSSESSION = 'SET_GIMMICK_POSSESSION';
export const SET_ORDER_PERCENTAGE = 'SET_ORDER_PERCENTAGE';

export const SET_BEST_SALES_GIMMICK = 'SET_BEST_SALES_GIMMICK';
export const SET_MOST_PRODUCED_GIMMICK = 'SET_MOST_PRODUCED_GIMMICK';
export const SET_ORDER_PURCHASE = 'SET_ORDER_PURCHASE';

export const SET_PROPORTION_SCALING = 'SET_PROPORTION_SCALING';

export const SET_PASSWORD = 'SET_PASSWORD';

export const SET_USERS = 'SET_USERS';

export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_CUSTOMER = 'SET_CUSTOMER';

export const SET_DOCTORS = 'SET_DOCTORS';
export const SET_DOCTOR = 'SET_DOCTOR';

export const SET_CHEMISTS = 'SET_CHEMISTS';
export const SET_CHEMIST = 'SET_CHEMIST';

export const SET_SPONSORS = 'SET_SPONSORS';
export const SET_SPONSOR = 'SET_SPONSOR';
export const SET_PRODUCTSPONSOR = 'SET_PRODUCTSPONSOR';

export const SET_PHARMACIES = 'SET_PHARMACIES';
export const SET_PHARMACY = 'SET_PHARMACY';

export const SET_BANNERS = 'SET_BANNERS';
export const SET_BANNER = 'SET_BANNER';

export const SET_SKILL = 'SET_SKILL';
export const SET_SOFTSKILL = 'SET_SOFTSKILL';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_HARD_SKILL = 'SET_HARD_SKILL';

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PRODUCT_CATEGORIES = 'SET_PRODUCT_CATEGORIES';

export const SET_PROMOTEDPRODUCTS = 'SET_PROMOTEDPRODUCTS';
export const SET_PROMOTEDPRODUCT = 'SET_PROMOTEDPRODUCT';

export const SET_CHAT = 'SET_CHAT';
export const SET_CHATS = 'SET_CHATS';
export const SET_REVIEW = 'SET_REVIEW';
export const SET_APPOINTMENT = 'SET_APPOINTMENT';
export const SET_DETAILAPPOINTMENT = 'SET_DETAILAPPOINTMENT';
export const SET_NOTE = 'SET_NOTE';
export const SET_NOTES = 'SET_NOTES';
export const SET_NOTE_DETAIL = 'SET_NOTE_DETAIL';
export const SET_SUMMARY_PHARMACY = 'SET_SUMMARY_PHARMACY';
export const SET_SUMMARY_DOCTOR = 'SET_SUMMARY_DOCTOR';
export const SET_SHCEDULE = 'SET_SHCEDULE';
export const SET_POSTSHCEDULE = 'SET_POSTSHCEDULE';
export const SET_HISTORY = 'SET_HISTORY';

export const SET_ARTICLE = 'SET_ARTICLE';
export const SET_ALLARTICLE = 'SET_ALLARTICLE';
export const SET_ARTICLES = 'SET_ARTICLES';
export const SET_STATUS = 'SET_STATUS';

export const SET_PROMOTIONS = 'SET_PROMOTIONS';
export const SET_PROMOTION = 'SET_PROMOTION';
export const SET_PROMO = 'SET_PROMO';

export const SET_PRESCRIPTIONS = 'SET_PRESCRIPTIONS';
export const SET_PRESCRIPTION = 'SET_PRESCRIPTION';

export const SET_BRANDS = 'SET_BRANDS';
export const SET_BRAND = 'SET_BRAND';

export const SET_ROLES = 'SET_ROLES';
export const SET_ROLE = 'SET_ROLE';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_PERMISSION = 'SET_PERMISSION';

export const SET_ADMINS = 'SET_ADMINS';
export const SET_ADMIN = 'SET_ADMIN';

export const SET_CEMPAIGN = 'SET_CEMPAIGN';
export const SET_CEMPAIGNS = 'SET_CEMPAIGNS';
export const SET_CAMPAIGNCUSTOMER = 'SET_CAMPAIGNCUSTOMER';
export const SET_DOWNLOAD = 'SET_DOWNLOAD';

export const SET_MASTERCEMPAIGN = 'SET_MASTERCEMPAIGN';
export const SET_MASTERCEMPAIGNS = 'SET_MASTERCEMPAIGNS';
export const SET_MASTERCEMPAIGNGROUP = 'SET_MASTERCEMPAIGNGROUP';

export const SET_ARTICLE_PRODUCT = 'SET_ARTICLE_PRODUCT';
export const SET_ARTICLE_PRODUCTS = 'SET_ARTICLE_PRODUCTS';
export const SET_PRODUCTARTICLE = 'SET_PRODUCTARTICLE';

export const SET_BIODATA = 'SET_BIODATA';
export const SET_BIODATAS = 'SET_BIODATAS';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_LOCATIONS2 = 'SET_LOCATIONS2';
export const SET_DESEASE = 'SET_DESEASE';

export const SET_EDUCARION = 'SET_EDUCARION';
export const SET_EDUCARIONS = 'SET_EDUCARIONS';
export const SET_INSTITUTION = 'SET_INSTITUTION';

export const SET_JOB = 'SET_JOB';
export const SET_JOBS = 'SET_JOBS';
export const SET_EXPIRE = 'SET_EXPIRE';
export const SET_SKILLS = 'SET_SKILLS';
export const SET_POINT = 'SET_POINT';
export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_JOBSTATUS = 'SET_JOBSTATUS';
export const SET_ID_QUIZ = 'SET_ID_QUIZ';

export const SET_EXPERIENCE = 'SET_EXPERIENCE';
export const SET_EXPERIENCES = 'SET_EXPERIENCES';
export const SET_CERTIFICATE = 'SET_CERTIFICATE';

export const SET_VERIFICATION = 'SET_VERIFICATION';
export const SET_USERS_FILE = 'SET_USERS_FILE';
